import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/auth";
import { Icon } from "@/components/kit";

export default function WeeklyBrief() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/weekly-brief").then((r) => setD(r.data)).catch((e) => console.error("weekly brief:", e)); }, []);
  if (!d) return <div className="text-slate-500 font-head">Preparing your weekly brief…</div>;

  const weekOf = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="fade-up space-y-6">
      <section className="rounded-[26px] bg-gradient-to-br from-[#12151F] to-[#0C0E14] border border-[#222938] p-6 md:p-8 relative overflow-hidden" data-testid="weekly-hero">
        <div className="absolute -top-24 -right-16 w-72 h-72 rounded-full bg-amber-500/10 blur-3xl" />
        <div className="relative">
          <div className="text-xs font-semibold tracking-[0.16em] uppercase text-amber-400 mb-2">Your MFDx Weekly Brief · Week of {weekOf}</div>
          <h1 className="font-head text-3xl md:text-4xl font-bold tracking-tight text-slate-50">Good Monday, {d.name}</h1>
          <p className="text-slate-400 mt-2 max-w-2xl">{d.focus}</p>
          <button onClick={() => nav("/app/tasks")} data-testid="start-my-week-btn"
            className="mt-5 grad-amber text-black font-semibold px-6 py-3 rounded-xl amber-glow hover:brightness-105 transition inline-flex items-center gap-2">
            <Icon name="CalendarCheck" size={17} /> Start My Week
          </button>
        </div>
      </section>

      <section>
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 rounded-xl grid place-items-center bg-emerald-500/12"><Icon name="History" size={18} className="text-emerald-400" /></div>
          <div><h2 className="font-head font-semibold text-lg text-slate-100 leading-tight">Last week</h2><p className="text-xs text-slate-500">What you got done</p></div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="weekly-last">
          {d.last_week.map((m) => (
            <div key={m.label} className="card-mfx p-5">
              <div className="flex items-center justify-between"><span className="text-xs text-slate-400">{m.label}</span><Icon name={m.icon} size={16} className="text-slate-500" /></div>
              <div className="font-head font-extrabold text-3xl text-slate-50 mt-2">{m.value}</div>
              <div className={`text-xs mt-1 font-medium ${m.delta >= 0 ? "text-emerald-400" : "text-red-400"}`}>{m.delta >= 0 ? "▲" : "▼"} {Math.abs(m.delta)} vs prior week</div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 rounded-xl grid place-items-center bg-amber-500/12"><Icon name="Flag" size={18} className="text-amber-400" /></div>
          <div><h2 className="font-head font-semibold text-lg text-slate-100 leading-tight">This week's priorities</h2><p className="text-xs text-slate-500">Focus here to move the needle</p></div>
        </div>
        <div className="space-y-2" data-testid="weekly-priorities">
          {d.this_week.map((p, i) => (
            <button key={p.title} onClick={() => nav(p.path)} data-testid={`weekly-priority-${i}`}
              className="w-full text-left card-mfx p-4 hover-lift flex items-center gap-4">
              <span className="w-10 h-10 rounded-xl grid place-items-center bg-amber-500/12 shrink-0 font-head font-bold text-amber-400">{i + 1}</span>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-slate-100 flex items-center gap-2"><Icon name={p.icon} size={15} className="text-slate-400" />{p.title}</div>
                <div className="text-sm text-slate-500 mt-0.5">{p.detail}</div>
              </div>
              <Icon name="ArrowRight" size={16} className="text-slate-600 shrink-0" />
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
